import Styled from 'styled-components/macro';
import {Avatar, tokensForThemeProvider} from '@forecast-it/design-system';

const RAIL_WIDTH = '20px';
const ICON_CENTRE = '10px';

/**
 * The log's left rail: one continuous vertical line behind every entry's icon. There is no
 * design-system primitive for this — Separator is horizontal and takes no props — so the line is
 * drawn here, using the shared border token rather than a literal colour.
 */
export const Timeline = Styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	gap: ${tokensForThemeProvider.sky.sys.spacing[500]};

	&::before {
		content: '';
		position: absolute;
		left: ${ICON_CENTRE};
		/* Stops at the first and last icon centre so the line never overhangs the log. */
		top: ${ICON_CENTRE};
		bottom: ${ICON_CENTRE};
		width: 1px;
		background-color: ${tokensForThemeProvider.sky.sys.color.border.decorative};
	}
`;

export const TimelineEntry = Styled.div`
	position: relative;
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	gap: ${tokensForThemeProvider.sky.sys.spacing[300]};
`;

/**
 * Sits on top of the rail and carries the surface colour, so the line reads as passing behind the
 * icon rather than through it.
 */
export const TimelineIcon = Styled.div`
	position: relative;
	z-index: 1;
	flex: 0 0 ${RAIL_WIDTH};
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: ${tokensForThemeProvider.sky.sys.color.background.neutral['1']};
	padding: ${tokensForThemeProvider.sky.sys.spacing[100]} 0;
`;

export const TimelineBody = Styled.div`
	display: flex;
	flex-direction: column;
	gap: ${tokensForThemeProvider.sky.sys.spacing[100]};
	flex: 1;
	min-width: 0;
`;

/** The design-system Avatar is a rounded square; the log shows people as circles. */
export const RoundAvatar = Styled(Avatar)`
	border-radius: 50%;
`;
